const conversion = 1.609344;

export function milesToKm(value: string): string {
    const result = parseFloat(value) * conversion;
    return result.toFixed(2);
}

export function kmToMiles(value: string): string {
    const result = parseFloat(value) / conversion;
    return result.toFixed(2);
}

